module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "benefit"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-benefit1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('benefit_item1')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-benefit2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('benefit_item2')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-benefit3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('benefit_item3')) + "\n            ")])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "prev"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-arrow.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "next"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-arrow.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29729968!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotion/Netflix/Benefit.vue
// module id = 1288
// module chunks = 1